import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Logo from 'assets/authentication/logo-top-bar.svg'
import styles from "./TopBar.module.scss";
import { Button } from "primereact/button";
import { auth0Logout } from "features/authentication/authSlices";
import { useNavigate } from "react-router-dom";
import WithdrawalOverlay from "features/profile/components/withdrawal-overlay/withdrawal-overlay";
import { getNotifications } from "features/profile/shopSlices";

const TopBar = () => {
  const dispatch: Function = useDispatch();
  const user = useSelector((state: any) => state.auth.user);
  const navigate = useNavigate();
  const [showWithdrawals, setShowWithdrawals] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const selectedShop = useSelector((state: any) => state.user.selectedShop);
  const [newNotifications, setNewNotifications] = useState(0);
  const notifications = useSelector((state: any) => state.shop.notifications);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Track new notifications by comparing with last seen date
  useEffect(() => {
    if (notifications) {
      // Get last seen timestamp from localStorage or use epoch start if not available
      const lastSeenTimestamp = localStorage.getItem('lastSeenNotificationTimestamp') 
        ? new Date(localStorage.getItem('lastSeenNotificationTimestamp') || '').getTime() 
        : 0;
      
      const unseen = notifications.filter(
        (notification: any) => {
          const notificationDate = new Date(notification.created_at + 'Z').getTime();
          return notificationDate > lastSeenTimestamp;
        }
      )
      const unseenCount = unseen.length;
      setNewNotifications(unseenCount);
    }
  }, [notifications]);


  const handleLogout = () => {
    dispatch(auth0Logout(navigate));
  }

  const fetchNotifications = () => {
    const savedIceCreamThreshold = localStorage.getItem('iceCreamThreshold');
    const date = new Date(localStorage.getItem('lastDeletionTimestamp') || 0);
    const formattedDate = date.toISOString();
    
    dispatch(getNotifications(selectedShop, savedIceCreamThreshold, formattedDate));
  }
  
  // Reset notification counter by updating the last seen timestamp
  const toggleWithdrawals = () => {
    if (!showWithdrawals) {
      // Mark current time as the last time notifications were viewed - store as UTC timestamp
      const currentTimestamp = new Date().toISOString();
      localStorage.setItem('lastSeenNotificationTimestamp', currentTimestamp);
      setNewNotifications(0);
    }
    setShowWithdrawals(!showWithdrawals);
  }
  
  //fetch every minute
  useEffect(() => {
    // Initial fetch
    fetchNotifications();
    
    const interval = setInterval(() => {
      fetchNotifications();
    }, 15000);
    return () => clearInterval(interval);
  }, [selectedShop]);
  return (
    <div className={styles.TopBar}>
      <img src={Logo} alt="Logo" className={styles.Logo}/>
      <div className={styles.UserContainer}>
        {!isMobile && user.roleLevel >= 2 && (
          <div className={styles.NotificationContainer}>
            <div 
              className={styles.NotificationBell}
              onClick={toggleWithdrawals}
            >
              <i className="pi pi-bell" />
              Notifications
              {newNotifications > 0 && (
                <span className={styles.NotificationBadge}>{newNotifications}</span>
              )}
            </div>
            {showWithdrawals && (
              <WithdrawalOverlay onClose={() => setShowWithdrawals(false)} />
            )}
          </div>
        )}
        <div className={styles.Separator}></div>
        <div>{user.name}</div>
        <div className={styles.Separator}></div>
        <Button 
          label={isMobile ? "" : "Sign Out"}
          className={styles.LogoutButton} 
          icon="pi pi-sign-out" 
          text 
          onClick={() => handleLogout()}
        />
      </div>
    </div>
  );
};

export default TopBar;
